import React, { useEffect, useState } from 'react';
import { Button, Container, Dropdown, Form, Grid, Icon, Menu, Message, Modal, Segment, Sidebar, Accordion } from 'semantic-ui-react';
import 'semantic-ui-css/semantic.min.css';
import { useNavigate } from "react-router-dom";
import SessionStorage from "../../store/session";
import { backgroundRepeat } from "html2canvas/dist/types/css/property-descriptors/background-repeat";
import ChangePassword from "../../pages/password/change-password";
import { useBlockUI } from "../services/block-ui-service";
import ChangeUserPassword, { ChangePasswordRequest } from "../../services/password/change-password";
import { toast } from "react-toastify";
import PasswordRequirementsHint from "../../shared/components/PasswordRequirementsHint";
import { isPasswordPolicyValid } from "../../shared/utils/password-policy";

interface Props {
    children: React.ReactNode;
    profile: string;
    isLogged: boolean;
    username: string;
}

const MasterContainer = ({ children, profile, isLogged = false, username = "" }: Props) => {
    const [visible, setVisible] = useState(false);
    const navigate = useNavigate();
    const [loading, setLoading] = useState<boolean>(false);
    const blockUI = useBlockUI();
    const [modalPassword, setModalPassword] = useState<Partial<ChangePasswordRequest>>({});
    const [isChangePasswordModalOpen, setIsChangePasswordModalOpen] = useState(false);
    const [activeIndex, setActiveIndex] = useState<number | null>(null);

    const toggleSidebar = () => {
        setVisible(!visible);
    };

    const handleAccordionClick = (index: number) => {
        if (activeIndex === index) {
            setActiveIndex(null);
        } else {
            setActiveIndex(index);
        }
    };

    const incompleteItemOfMenu = true;

    useEffect(() => {
        if (!profile)
            window.location.reload()
    }, [])

    const [passwordChangeError, setPasswordChangeError] = useState('');

    const handleSubmit = async () => {
        try {
            setLoading(true);
            setPasswordChangeError('');
            if (!modalPassword.currentPassword || !modalPassword.password || !modalPassword.passwordConfirmation) {
                setPasswordChangeError('Preencha todos os campos.');
                return;
            }
            if (modalPassword.password !== modalPassword.passwordConfirmation) {
                setPasswordChangeError('A confirmação da nova senha não confere.');
                return;
            }
            if (!isPasswordPolicyValid(modalPassword.password)) {
                setPasswordChangeError('A nova senha não atende aos requisitos abaixo.');
                return;
            }
            const result = await ChangeUserPassword(modalPassword);
            if (result.success)
                toast.success('Senha atualizada com sucesso', {
                    position: 'top-center',
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: 'light',
                });
            setIsChangePasswordModalOpen(false);
            setModalPassword({});
        } finally {
            setLoading(false);
        }
    };

    const openChangePasswordModal = () => {
        setIsChangePasswordModalOpen(true);
        setModalPassword({});
        setPasswordChangeError('');
    };

    if (isLogged)
        return (
            <Sidebar.Pushable>
                <Sidebar
                    as={Menu}
                    animation='slide along'
                    icon='labeled'
                    onHide={() => setVisible(false)}
                    vertical
                    visible={visible}
                    width='wide'
                >
                    <Menu.Header
                        name='home'
                        onClick={() => navigate('/')}>

                        <img src={'/logotipo.png'}
                             style={{ maxHeight: '4rem', marginTop: 20, paddingBottom: 5 }}
                             alt={'fleetgame'} />
                        <hr />
                    </Menu.Header>
                    {profile == 'Admin' &&
                        <Accordion fluid styled>
                            <Accordion.Title
                                active={activeIndex === 0}
                                index={0}
                                onClick={() => handleAccordionClick(0)}
                            >
                                <Menu.Item
                                    name='cadastros'>
                                    <Icon name="users" color={'green'} />
                                    Cadastros de Usuários
                                </Menu.Item>
                            </Accordion.Title>
                            <Accordion.Content active={activeIndex === 0}>
                                <Menu.Item
                                    name='backoffice-users'
                                    onClick={() => {
                                        navigate('/backoffice/users/')
                                        setVisible(false)
                                    }}>
                                    Usuários do backoffice
                                </Menu.Item>
                                <Menu.Item
                                    name='clientes'
                                    onClick={() => {
                                        navigate('/backoffice/clients/')
                                        setVisible(false)
                                    }}>
                                    Clientes
                                </Menu.Item>
                                <Menu.Item
                                    name='gestores'
                                    onClick={() => {
                                        navigate('/backoffice/managers/')
                                        setVisible(false)
                                    }}>
                                    Gestores
                                </Menu.Item>
                                <Menu.Item
                                    name='motoristas-users'
                                    onClick={() => {
                                        navigate('/backoffice/motoristas/')
                                        setVisible(false)
                                    }}>
                                    Motoristas
                                </Menu.Item>
                            </Accordion.Content>
                        </Accordion>
                    }

                    {profile === 'Manager' &&
                        <Menu.Item
                            name='gestores-manager'
                            onClick={() => {
                                navigate('/backoffice/managers/')
                                setVisible(false)
                            }}>
                            <Icon name="users" color={'green'} />
                            Gestores
                        </Menu.Item>
                    }

                    {(profile === 'Admin' || profile === 'Manager') &&
                        <Accordion fluid styled>
                            <Accordion.Title
                                active={activeIndex === 1}
                                index={1}
                                onClick={() => handleAccordionClick(1)}
                            >
                                <Menu.Item
                                    name='operacoes'>
                                    <Icon name="truck" color={'green'} />
                                    Operações
                                </Menu.Item>
                            </Accordion.Title>
                            <Accordion.Content active={activeIndex === 1}>
                                <Menu.Item
                                    name='unidades-de-negocio'
                                    onClick={() => {
                                        navigate('/backoffice/business-units/')
                                        setVisible(false)
                                    }}>
                                    Unidades de Negócio
                                </Menu.Item>
                                <Menu.Item
                                    name='fleets'
                                    onClick={() => {
                                        navigate('/backoffice/fleets/')
                                        setVisible(false)
                                    }}>
                                    Frota
                                </Menu.Item>
                                <Menu.Item
                                    name='plates-users'
                                    onClick={() => {
                                        navigate('/backoffice/vehicle-plates/')
                                        setVisible(false)
                                    }}>
                                    Placas
                                </Menu.Item>

                            </Accordion.Content>
                        </Accordion>
                    }

                    {(profile === 'Admin' || profile === 'Manager') &&
                        <Accordion fluid styled>
                            <Accordion.Title
                                active={activeIndex === 2}
                                index={2}
                                onClick={() => handleAccordionClick(2)}
                            >
                                <Menu.Item
                                    name='torre'>
                                    <Icon name="building" color={'green'} />
                                    Torre
                                </Menu.Item>
                            </Accordion.Title>
                            <Accordion.Content active={activeIndex === 2}>
                                <Menu.Item
                                    name='home'
                                    onClick={() => {
                                        navigate('/torre/index.tsx');
                                        setVisible(false);
                                    }}>
                                    Home
                                </Menu.Item>
                                <Menu.Item
                                    name='programming'
                                    onClick={() => {
                                        navigate('/backoffice/programming/')
                                        setVisible(false)
                                    }}>
                                    Programações
                                </Menu.Item>
                                <Menu.Item
                                    name='vehicle-types'
                                    onClick={() => {
                                        navigate('/torre/vehicle-types');
                                        setVisible(false);
                                    }}>
                                    Tipos de veículos
                                </Menu.Item>
                                <Menu.Item
                                    name='fleet-types'
                                    onClick={() => {
                                        navigate('/torre/fleet-types');
                                        setVisible(false);
                                    }}>
                                    Tipos de Frota
                                </Menu.Item>
                                <Menu.Item
                                    name='operation-types'
                                    onClick={() => {
                                        navigate('/torre/operation-types');
                                        setVisible(false);
                                    }}>
                                    Tipos de operação
                                </Menu.Item>
                                <Menu.Item
                                    name='reference-groups'
                                    onClick={() => {
                                        navigate('/torre/reference-groups');
                                        setVisible(false);
                                    }}>
                                    Grupos de referência
                                </Menu.Item>
                                <Menu.Item
                                    name='references'
                                    onClick={() => {
                                        navigate('/torre/references');
                                        setVisible(false);
                                    }}>
                                    Referencias
                                </Menu.Item>
                                <Menu.Item
                                    name='justifications'
                                    onClick={() => {
                                        navigate('/torre/justifications');
                                        setVisible(false);
                                    }}>
                                    Justificativas
                                </Menu.Item>
                                <Menu.Item
                                    name='routes'
                                    onClick={() => {
                                        navigate('/torre/routes');
                                        setVisible(false);
                                    }}>
                                    Rotas
                                </Menu.Item>
                                <Menu.Item
                                    name='products'
                                    onClick={() => {
                                        navigate('/torre/products');
                                        setVisible(false);
                                    }}>
                                    Produtos
                                </Menu.Item>
                            </Accordion.Content>
                        </Accordion>
                    }

                    {(profile === 'Admin' || profile === 'Manager') &&
                        <Menu.Item
                            name='dashboard'
                            onClick={() => {
                                navigate('/backoffice/dashboard')
                                setVisible(false)
                            }}>
                            <Icon name="dashboard" color={'green'} />
                            Dashboard
                        </Menu.Item>
                    }

                    {(profile === 'Admin' || profile === 'Manager') &&
                        <Menu.Item
                            name='relatorio-geral'
                            onClick={() => {
                                navigate('/backoffice/relatorios/geral')
                                setVisible(false)
                            }}>
                            <Icon name="chart bar" color={'green'} />
                            Relatório de premiação
                        </Menu.Item>
                    }

                    {profile === 'Admin' &&
                        <Menu.Item
                            name='rastreamento-logs'
                            onClick={() => {
                                navigate('/backoffice/rastreamento-logs/list')
                                setVisible(false)
                            }}>
                            <Icon name="list alternate outline" color={'green'} />
                            Logs de rastreamento
                        </Menu.Item>
                    }

                    <Menu.Item
                        name='sair'
                        onClick={() => {
                            SessionStorage.deleteSession()
                            navigate('/')
                            window.location.reload()
                        }}
                    >
                        <Icon name='sign-out' color={'red'} />
                        Sair
                    </Menu.Item>
                </Sidebar>
                <Sidebar.Pusher dimmed={visible}>
                    <div suppressContentEditableWarning
                         style={{
                             backgroundImage: 'url(/page_bg_top.png), url(/page_bg_bottom.png)',
                             backgroundSize: 'auto',
                             backgroundRepeat: 'no-repeat, no-repeat',
                             backgroundPosition: 'center top, center bottom'
                         }}>
                        <Menu stackable>
                            <Menu.Item as='a' onClick={toggleSidebar} className={'no-print'} color={'green'}>
                                <Icon name={'bars'} size={'large'} color={'green'} />
                                <span>Menu</span>
                            </Menu.Item>
                            <Menu.Item as='a'
                                       position={'right'}
                                       onClick={toggleSidebar}
                                       className={'no-print'}
                                       name={'MENU'}
                                       color={'green'}>
                                <img src={'/logotipo.png'} style={{
                                    maxHeight: '3rem',
                                    objectFit: 'contain',
                                    marginTop: 10,
                                    marginBottom: 10,
                                    paddingBottom: 5,
                                    alignSelf: 'center',
                                    width: '100%',
                                }} alt={'fleetgame'} />
                            </Menu.Item>
                            <Dropdown
                                className={'floated right'}
                                text={`Bem-vindo(a), ${username}`}
                                item
                            >
                                <Dropdown.Menu>
                                    <Dropdown.Item
                                        text="Alterar Senha"
                                        icon="lock"
                                        onClick={openChangePasswordModal}
                                    />
                                    <Dropdown.Item
                                        onClick={() => {
                                            SessionStorage.deleteSession();
                                            window.location.reload();
                                        }}>
                                        <Icon name='log out' color={'red'} />
                                        Sair
                                    </Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </Menu>
                        <Container fluid>
                            <Grid>
                                <Grid.Row>
                                    <Grid.Column style={{ width: '100%' }}>
                                        <Grid.Row style={{ width: '100%', padding: '5%' }}>
                                            {children}
                                        </Grid.Row>
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                        </Container>
                    </div>
                </Sidebar.Pusher>
                <Modal open={isChangePasswordModalOpen} onClose={() => setIsChangePasswordModalOpen(false)}
                       onOpen={openChangePasswordModal}>
                    <Modal.Header>Alterar Senha</Modal.Header>
                    <Modal.Content>
                        <Form size="large">
                            <Segment stacked>
                                <Form.Input
                                    label="Senha Atual"
                                    name="currentPassword"
                                    type="password"
                                    placeholder="Senha Atual"
                                    value={modalPassword.currentPassword || ''}
                                    onChange={(event) => setModalPassword({
                                        ...modalPassword,
                                        currentPassword: event.target.value
                                    })}
                                />
                                <Form.Input
                                    label="Nova Senha"
                                    name="newPassword"
                                    type="password"
                                    placeholder="Nova Senha"
                                    value={modalPassword.password || ''}
                                    onChange={(event) => setModalPassword({
                                        ...modalPassword,
                                        password: event.target.value
                                    })}
                                />
                                <Form.Input
                                    label="Confirmar Nova Senha"
                                    name="confirmNewPassword"
                                    type="password"
                                    placeholder="Confirmar Nova Senha"
                                    value={modalPassword.passwordConfirmation || ''}
                                    onChange={(event) => setModalPassword({
                                        ...modalPassword,
                                        passwordConfirmation: event.target.value
                                    })}
                                />
                                <PasswordRequirementsHint password={modalPassword.password} compact />
                                {passwordChangeError && (
                                    <Message negative size="small">{passwordChangeError}</Message>
                                )}
                            </Segment>
                        </Form>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button color="blue" onClick={handleSubmit}>
                            Alterar Senha
                        </Button>
                        <Button color="red" onClick={() => setIsChangePasswordModalOpen(false)}>
                            Fechar
                        </Button>
                    </Modal.Actions>
                </Modal>
            </Sidebar.Pushable>
        );
    else
        return <div>{children}</div>
};

export default MasterContainer;
